var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          value: { animation: false },
          expression: "{ animation: false}",
          modifiers: { hover: true }
        }
      ],
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        href: "javascript:;",
        "data-target": _vm.modalSelector,
        "data-toggle": "modal",
        title: _vm.$t("messages.countdown_title")
      },
      on: {
        click: function($event) {
          return _vm.setActiveParams(_vm.index, _vm.itemID)
        }
      }
    },
    [_c("i", { staticClass: "fas fa-clock" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }